import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, DialogTitle, Stack, Icon, DialogContentText } from "@mui/material";
import { WarningRounded } from '@material-ui/icons';







export default function ErrorPopup({ error, discount, onClose }) {


  return error && (
    <Dialog disablePortal open={!!error} onClose={onClose}>
      <DialogTitle>
        <Stack direction='row' justifyContent={discount ? 'space-between' : 'center'}>
          <Icon sx={{ color: 'red', }}><WarningRounded /></Icon>
          {discount && (
            <>
              {discount}
              <Icon sx={{ color: 'red', }}><WarningRounded /></Icon>
            </>
          )}
        </Stack>
      </DialogTitle>
      <DialogContent >
        <DialogContentText dangerouslySetInnerHTML={{ __html: error }} />
      </DialogContent>
      <DialogActions>
        <Button fullWidth size='small' variant='contained' onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog >
  )
}